import _classCallCheck from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var Theme =
/*#__PURE__*/
function () {
  function Theme(quill, options) {
    _classCallCheck(this, Theme);

    this.quill = quill;
    this.options = options;
    this.modules = {};
  }

  _createClass(Theme, [{
    key: "init",
    value: function init() {
      var _this = this;

      Object.keys(this.options.modules).forEach(function (name) {
        if (_this.modules[name] == null) {
          _this.addModule(name);
        }
      });
    }
  }, {
    key: "addModule",
    value: function addModule(name) {
      var moduleClass = this.quill.constructor.import("modules/".concat(name));
      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
      return this.modules[name];
    }
  }]);

  return Theme;
}();

Theme.DEFAULTS = {
  modules: {}
};
Theme.themes = {
  'default': Theme
};
export default Theme;